<template>
    <span>
        <span :class="['ticket-priority ticket-priority--' + transformToModifierClass(value)]"></span>
        <span class="ticket-priority__text" v-if="withText">{{ text }}</span>
    </span>
</template>

<script>
    import StyleMixin from '@/mixins/StyleMixin'

    export default {
        mixins: [StyleMixin],

        props: {
            value: String,
            text: String,
            withText: {
                type: Boolean,
                default: false
            }
        },
    }
</script><style lang="scss">@import "@/assets/scss/components/HelpDesk/_ticketpriority.scss";</style>